export declare const player: (player: Player) => void;
declare global {
    interface Player {
        /** Send the specified `brand` to the player or `flying-squid` by default */
        "sendBrand": (brand?: string) => Promise<void>;
    }
}
